<template>
    <transition name="fade">
        <div
            v-if="opened"
            class="l-ss-c-popup"
            :class="{
                'l-ss-c-popup-opened': opened,
                'l-ss-c-popup-mobile': $screen.isMobile
            }"
            v-click-outside="emitCloseFromClickOutside">
            <div class="l-ss-c-popup-inner">
                <button
                    v-if="showCloseIcon"
                    class="l-ss-c-button l-ss-c-button-plain l-ss-c-popup-close"
                    @click="emitClose">
                    <i
                        :class="{ 'l-ss-c-popup-icon-mounted': isMounted }"
                        v-html="iconClosePopup"></i>
                </button>
                <h2
                    class="l-ss-c-popup-title"
                    v-if="title">
                    {{ title }}&nbsp;
                </h2>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
    import { onMounted, watch, ref, inject } from '@/lib/vue-composition-api.js';

    import iconClosePopup from '../assets/images/icons/close-popup.svg';

    import ClickOutside from '../../core/directives/clickOutside.js';

    export default {
        directives: {
            'click-outside': ClickOutside,
        },
        props: {
            title: {
                type: String,
                default: '',
            },
            opened: {
                type: Boolean,
                default: false,
            },
            showCloseIcon: {
                type: Boolean,
                default: true,
            },
            scrollToTopOnMobile: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { emit, root }) {
            const isMounted = ref(false);
            const isAvailableClose = ref(false);

            const scrollToTop = inject('scrollToTop');

            onMounted(() => {
                isMounted.value = true;
            });

            const emitClose = () => {
                if (isAvailableClose.value) {
                    emit('close');
                }
            };

            const emitCloseFromClickOutside = () => {
                if (root.$screen.isMobile) {
                    return;
                }

                emitClose();
            };

            watch(() => props.opened, (value) => {
                if (value) {
                    if (props.scrollToTopOnMobile && root.$screen.isMobile) {
                        scrollToTop({ behavior: 'auto' });
                    }

                    setTimeout(() => {
                        isAvailableClose.value = true;
                    });
                } else {
                    isAvailableClose.value = false;
                }
            });

            return {
                isMounted,
                iconClosePopup,
                emitClose,
                emitCloseFromClickOutside,
            };
        },
    };
</script>

